import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import ImoveisMeiliPage from '@/pages/imoveis/imoveis-meili-page'
import { ProtectedRoute, RequireModule } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { MODULES } from '@/constants/modules'

const imoveisSearchSchema = z.object({
  page: z.coerce.number().min(1).optional(),
})

// Rota index para /dashboard/$dashboardId/imoveis
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/imoveis/',
)({
  validateSearch: imoveisSearchSchema,
  component: function ImoveisIndexRoute() {
    const { dashboardId } = Route.useParams()
    return (
      <RequireModule module={MODULES.IMOVEIS} dashboardId={dashboardId}>
        <ProtectedRoute capability={CAPABILITIES.VIEW_IMOB_DATA}>
          <ImoveisMeiliPage dashboardId={dashboardId} />
        </ProtectedRoute>
      </RequireModule>
    )
  },
})
